import {get,post} from './base.service'

export default{
    /* 获取区域列表 */
    loadArea(params){
        return get('/yxt/family/addresss',{params:params});
    },
    /* 获取医生团队 */
    loadDoctorTeam(params){
        return get('/yxt/family/user/doctorGroups',{params:params});
    },
    loadFollow(params){
        return get('/yxt/family/follows',{params:params});
    },
    loadSignStatus(params){
        return get('/yxt/family/user/contract/{idcard}',{params:params})
    },
    submitSign(params){
        return post(`/yxt/family/user/contract?idcard=${params.idcard}&doctorGroupId=${params.doctorGroupId}&followId=${params.followId}&name=${params.name}&phone=${params.phone}`,params)
    }
}



// WEBPACK FOOTER //
// ./src/service/region.service.js